/**
 * R-28 — SED rebuild diff-guard thresholds and feature flag.
 */

function parseEnvFloat(nodeKey: string, viteKey: string, fallback: number): number {
  if (typeof process !== 'undefined' && process.env?.[nodeKey] != null) {
    const v = Number(process.env[nodeKey]);
    if (Number.isFinite(v)) return v;
  }
  if (typeof import.meta !== 'undefined' && import.meta.env?.[viteKey] != null) {
    const v = Number(import.meta.env[viteKey]);
    if (Number.isFinite(v)) return v;
  }
  return fallback;
}

function parseEnvInt(nodeKey: string, viteKey: string, fallback: number): number {
  return Math.round(parseEnvFloat(nodeKey, viteKey, fallback));
}

function parseEnvBool(nodeKey: string, viteKey: string, fallback: boolean): boolean {
  if (typeof process !== 'undefined' && process.env?.[nodeKey] != null) {
    return process.env[nodeKey] === 'true';
  }
  if (typeof import.meta !== 'undefined' && import.meta.env?.[viteKey] != null) {
    return import.meta.env[viteKey] === 'true';
  }
  return fallback;
}

export const SED_CONFIG = {
  /** When true, rebuilds run through rebuildSedWithGuard. Default on. */
  DIFF_GUARD_ENABLED: parseEnvBool(
    'SED_REBUILD_DIFF_GUARD',
    'VITE_SED_REBUILD_DIFF_GUARD',
    true,
  ),
  /** Max allowed completeness drop (percentage points, e.g. 10 = 10pp). */
  MAX_COMPLETENESS_LOSS_PCT: parseEnvFloat(
    'SED_MAX_COMPLETENESS_LOSS_PCT',
    'VITE_SED_MAX_COMPLETENESS_LOSS_PCT',
    10,
  ),
  MAX_VERIFIED_SECTIONS_LOST: parseEnvInt(
    'SED_MAX_VERIFIED_SECTIONS_LOST',
    'VITE_SED_MAX_VERIFIED_SECTIONS_LOST',
    2,
  ),
  MAX_REGRESSED_SECTIONS: parseEnvInt(
    'SED_MAX_REGRESSED_SECTIONS',
    'VITE_SED_MAX_REGRESSED_SECTIONS',
    3,
  ),
  /** Max allowed verified-provider count drop (percent). // R-131-SCAR-D */
  MAX_PROVIDER_COUNT_DELTA_PCT: parseEnvFloat(
    'SED_MAX_PROVIDER_COUNT_DELTA_PCT',
    'VITE_SED_MAX_PROVIDER_COUNT_DELTA_PCT',
    30,
  ),
  /** Minimum override rationale length (chars). */
  OVERRIDE_RATIONALE_MIN_CHARS: 40,
  /** Firestore summary retention hint (days) — enforced by future TTL job. */
  FIRESTORE_SNAPSHOT_RETENTION_DAYS: 30,
  /** GCS raw snapshot retention hint (days). */
  GCS_SNAPSHOT_RETENTION_DAYS: 90,
} as const;
